var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopViewBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 900",
    style: {
      enableBackground: "new 0 0 1200 900"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 1200,
    height: 900
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D3E5F1"
    },
    d: "M1119.543,492.07c-6.642-87.467-56.246-164.698-111.313-230.082 c-26.077-30.963-53.552-61.054-82.024-89.832c-31.743-32.084-65.009-61.366-105.116-82.584 C781.05,68.39,734.052,60.177,689.367,68.556c-48.918,9.172-91.875,33.496-133.656,59.39 c-83.979,52.046-167.212,105.336-250.794,158.018c-36.727,23.15-74.421,45.324-109.336,71.193 c-17.971,13.315-34.479,27.98-50.018,44.058c-15.484,16.021-27.91,33.567-38.787,52.982 c-23.629,42.178-29.842,92.041-26.248,139.653c3.615,47.891,19.271,94.661,38.125,138.541 c5.39,12.544,40.025,77.962,48.777,81.558c6.795,2.792,807.764,20.214,828.029,9.524c22.001-11.604,40.687-28.227,53.731-49.528 c11.646-19.018,20.172-39.027,27.421-60.051c7.575-21.971,14.985-44.03,21.549-66.327 C1113.117,596.762,1123.586,545.301,1119.543,492.07z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#4B8AB7"
    },
    cx: 597.098,
    cy: 816.137,
    rx: 515.75,
    ry: 44.541
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B7D2E5"
    },
    d: "M918.003,729.247H890.5c-3.092,0-5.621-2.53-5.621-5.621v-27.503c0-3.092,2.53-5.621,5.621-5.621 h27.503c3.092,0,5.621,2.53,5.621,5.621v27.503C923.624,726.718,921.094,729.247,918.003,729.247z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9ABFDB"
    },
    cx: 904.251,
    cy: 709.875,
    r: 10.43
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B7D2E5"
    },
    d: "M898.523,709.875c0-0.686,0.556-1.242,1.242-1.242s1.242,0.556,1.242,1.242 c0,0.686-0.556,1.242-1.242,1.242S898.523,710.561,898.523,709.875z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#B7D2E5"
    },
    cx: 908.737,
    cy: 709.875,
    r: 1.242
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B7D2E5"
    },
    d: "M868.031,729.247h-27.503c-3.092,0-5.621-2.53-5.621-5.621v-27.503c0-3.092,2.53-5.621,5.621-5.621 h27.503c3.092,0,5.621,2.53,5.621,5.621v27.503C873.653,726.718,871.123,729.247,868.031,729.247z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5A95BD"
    },
    cx: 854.28,
    cy: 709.875,
    r: 10.43
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A95BD"
    },
    d: "M850.078,711.081c0.549-0.129,0.959-0.619,0.959-1.207c0-0.686-0.556-1.242-1.242-1.242 c-0.385,0-0.726,0.179-0.953,0.455c-0.018-0.026-0.034-0.052-0.052-0.078c-1.024-1.491-3.228,0.254-2.206,1.742 c10.269,14.957,1.043,36.81-14.769,43.534c-19.079,8.114-41.809-1.966-52.792-18.464c-3.057-4.593-5.278-9.824-6.179-15.279 c-0.985-5.961,0.002-11.903,0.159-17.882c0.145-5.503-0.618-10.69-3.408-15.506c-2.653-4.58-6.319-8.524-8.356-13.458 c-4.317-10.455-1.811-22.283-0.069-33.017c1.75-10.783,2.488-21.607,1.769-32.521c-1.599-24.289-9.782-47.992-23.526-68.077 c-1.021-1.493-3.225,0.253-2.206,1.742c13.248,19.361,21.121,42.168,22.866,65.552c0.879,11.774-0.117,23.325-2.019,34.945 c-1.82,11.119-3.835,23.337,1.245,33.93c2.393,4.991,6.371,9.008,8.77,13.985c2.87,5.953,2.16,12.516,1.736,18.893 c-0.375,5.64-0.254,11.101,1.363,16.557c1.539,5.19,4.135,10.051,7.41,14.352c12.032,15.801,34.616,24.79,53.713,17.091 C849.502,750.193,859.418,727.641,850.078,711.081z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A95BD"
    },
    d: "M857.524,709.875c0-0.686,0.556-1.242,1.242-1.242c0.686,0,1.242,0.556,1.242,1.242 c0,0.686-0.556,1.242-1.242,1.242C858.08,711.117,857.524,710.561,857.524,709.875z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507087"
    },
    d: "M205.837,763.402L205.837,763.402c-2.875,0-5.227-2.352-5.227-5.227v-72.929 c0-2.875,2.352-5.227,5.227-5.227l0,0c2.875,0,5.227,2.352,5.227,5.227v72.929C211.064,761.05,208.711,763.402,205.837,763.402z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F8EAA"
    },
    d: "M203.597,763.402L203.597,763.402c-2.875,0-5.227-2.352-5.227-5.227v-72.929 c0-2.875,2.352-5.227,5.227-5.227l0,0c2.875,0,5.227,2.352,5.227,5.227v72.929C208.823,761.05,206.471,763.402,203.597,763.402z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507087"
    },
    d: "M223.458,763.402L223.458,763.402c-2.875,0-5.227-2.352-5.227-5.227v-72.929 c0-2.875,2.352-5.227,5.227-5.227l0,0c2.875,0,5.227,2.352,5.227,5.227v72.929C228.685,761.05,226.333,763.402,223.458,763.402z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F8EAA"
    },
    d: "M221.219,763.402L221.219,763.402c-2.875,0-5.227-2.352-5.227-5.227v-72.929 c0-2.875,2.352-5.227,5.227-5.227h0c2.875,0,5.227,2.352,5.227,5.227v72.929C226.445,761.05,224.093,763.402,221.219,763.402z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507087"
    },
    d: "M241.08,763.402L241.08,763.402c-2.875,0-5.227-2.352-5.227-5.227v-72.929 c0-2.875,2.352-5.227,5.227-5.227l0,0c2.875,0,5.227,2.352,5.227,5.227v72.929C246.307,761.05,243.955,763.402,241.08,763.402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F8EAA"
    },
    d: "M238.84,763.402L238.84,763.402c-2.875,0-5.227-2.352-5.227-5.227v-72.929 c0-2.875,2.352-5.227,5.227-5.227l0,0c2.875,0,5.227,2.352,5.227,5.227v72.929C244.067,761.05,241.715,763.402,238.84,763.402z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F8EAA"
    },
    d: "M258.702,763.402L258.702,763.402c-2.875,0-5.227-2.352-5.227-5.227v-72.929 c0-2.875,2.352-5.227,5.227-5.227l0,0c2.875,0,5.227,2.352,5.227,5.227v72.929C263.929,761.05,261.577,763.402,258.702,763.402z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F8EAA"
    },
    d: "M256.462,763.402L256.462,763.402c-2.875,0-5.227-2.352-5.227-5.227v-72.929 c0-2.875,2.352-5.227,5.227-5.227l0,0c2.875,0,5.227,2.352,5.227,5.227v72.929C261.689,761.05,259.337,763.402,256.462,763.402z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507087"
    },
    d: "M310.672,763.402L310.672,763.402c2.875,0,5.227-2.352,5.227-5.227v-72.929 c0-2.875-2.352-5.227-5.227-5.227l0,0c-2.875,0-5.227,2.352-5.227,5.227v72.929C305.445,761.05,307.797,763.402,310.672,763.402 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F8EAA"
    },
    d: "M312.912,763.402L312.912,763.402c2.875,0,5.227-2.352,5.227-5.227v-72.929 c0-2.875-2.352-5.227-5.227-5.227l0,0c-2.875,0-5.227,2.352-5.227,5.227v72.929C307.685,761.05,310.037,763.402,312.912,763.402 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507087"
    },
    d: "M293.05,763.402L293.05,763.402c2.875,0,5.227-2.352,5.227-5.227v-72.929 c0-2.875-2.352-5.227-5.227-5.227l0,0c-2.875,0-5.227,2.352-5.227,5.227v72.929C287.823,761.05,290.175,763.402,293.05,763.402z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F8EAA"
    },
    d: "M295.29,763.402L295.29,763.402c2.875,0,5.227-2.352,5.227-5.227v-72.929 c0-2.875-2.352-5.227-5.227-5.227l0,0c-2.875,0-5.227,2.352-5.227,5.227v72.929C290.063,761.05,292.415,763.402,295.29,763.402z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507087"
    },
    d: "M274.084,763.402L274.084,763.402c2.875,0,5.227-2.352,5.227-5.227v-72.929 c0-2.875-2.352-5.227-5.227-5.227l0,0c-2.875,0-5.227,2.352-5.227,5.227v72.929C268.857,761.05,271.209,763.402,274.084,763.402 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F8EAA"
    },
    d: "M276.324,763.402L276.324,763.402c2.875,0,5.227-2.352,5.227-5.227v-72.929 c0-2.875-2.352-5.227-5.227-5.227l0,0c-2.875,0-5.227,2.352-5.227,5.227v72.929C271.097,761.05,273.449,763.402,276.324,763.402 z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 198.49,
    y: 753.479,
    style: {
      fill: "#6F8EAA"
    },
    width: 119.718,
    height: 33.971
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.49,
    y: 657.564,
    style: {
      fill: "#6F8EAA"
    },
    width: 119.718,
    height: 33.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#6F8EAA"
    },
    cx: 258.349,
    cy: 787.714,
    rx: 59.859,
    ry: 9.837
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#6F8EAA"
    },
    cx: 258.349,
    cy: 657.93,
    rx: 59.859,
    ry: 9.837
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#507087"
    },
    cx: 258.349,
    cy: 657.023,
    rx: 56.364,
    ry: 6.398
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507087"
    },
    d: "M318.208,690.993v-33.43h-0.046c-0.925-4.151-17.499-7.645-40.314-8.936 c-0.032,11.124-0.246,22.246-0.676,33.362c-1.495,38.695-5.464,77.308-11.901,115.496c29.797-0.564,52.936-4.723,52.936-9.771 c0-0.088-0.008-0.176-0.022-0.264h0.022v-33.971h-0.07v-62.486H318.208z M287.823,753.479h-6.272v-62.486h6.272V753.479z  M305.445,753.479h-4.928v-62.486h4.928V753.479z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M854.28,565.6l-0.005,0.038l-1.555,15.459l-0.796,7.903l-0.904,8.957L830.741,799.18 c-0.192,1.911-1.803,3.368-3.729,3.368h-6.338c-2.117,0-3.813-1.747-3.747-3.865l6.352-200.728l0.281-8.957l0.248-7.903 l0.492-15.459V565.6H854.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M977.706,798.683c0.07,2.117-1.626,3.865-3.743,3.865h-6.343c-1.925,0-3.537-1.457-3.729-3.368 l-20.274-201.225l-0.904-8.957l-0.796-7.903l-1.555-15.459l-0.005-0.038h29.98v0.038l0.492,15.459l0.248,7.903l0.281,8.957 L977.706,798.683z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEEDED"
    },
    points: "824.3,565.637 854.275,565.637 852.72,581.096 851.924,588.999 823.56,588.999  823.808,581.096  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEEDED"
    },
    points: "971.077,588.999 942.713,588.999 941.917,581.096 940.361,565.637 970.337,565.637  970.829,581.096  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEEDED"
    },
    d: "M268.863,802.55h-6.341c-2.116,0-3.813-1.751-3.746-3.866l7.373-233.083h29.98l-23.538,233.577 C272.399,801.092,270.787,802.55,268.863,802.55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEEDED"
    },
    d: "M409.471,802.55h6.341c2.116,0,3.813-1.751,3.746-3.866l-7.373-233.083h-29.98l23.538,233.577 C405.935,801.092,407.546,802.55,409.471,802.55z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2B263"
    },
    d: "M260.524,567.045h709.832c4.139,0,7.495-3.356,7.495-7.495v-29.087 c0-5.627-4.604-10.231-10.231-10.231H263.26c-5.627,0-10.231,4.604-10.231,10.231v29.087 C253.029,563.672,256.402,567.045,260.524,567.045z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE989"
    },
    d: "M992.749,516.353h-60.63H298.761h-60.629c-4.791,0-8.711,3.951-8.711,8.779v17.636 c0,4.828,3.92,8.779,8.712,8.779h58.873h636.872h58.873c4.791,0,8.712-3.951,8.712-8.779v-17.636 C1001.461,520.304,997.541,516.353,992.749,516.353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2B263"
    },
    d: "M999.592,516.353H815.225v35.194h184.367c4.062,0,7.355-2.849,7.355-6.363l0-22.467 C1006.946,519.203,1003.654,516.353,999.592,516.353z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 641.043,
    y: 417.828,
    style: {
      fill: "#9ABFDB"
    },
    width: 53.943,
    height: 96.215
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B7D2E5"
    },
    d: "M813.843,468.302H536.72V293.886h277.123c3.777,0,6.84,3.062,6.84,6.84v160.736 C820.683,465.24,817.62,468.302,813.843,468.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M726.121,517.036H609.908c-3.778,0-6.84-3.062-6.84-6.84v-2.565c0-3.777,3.062-6.84,6.84-6.84 h116.213c3.778,0,6.84,3.062,6.84,6.84v2.565C732.961,513.974,729.898,517.036,726.121,517.036z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M803.156,468.302H532.873c-3.778,0-6.84-3.062-6.84-6.84V300.726c0-3.778,3.062-6.84,6.84-6.84 h270.283c3.778,0,6.84,3.062,6.84,6.84v160.736C809.995,465.24,806.933,468.302,803.156,468.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F8EAA"
    },
    d: "M794.924,442.049H541.105c-3.268,0-5.917-2.649-5.917-5.917V308.462 c0-3.268,2.649-5.917,5.917-5.917h253.819c3.268,0,5.917,2.649,5.917,5.917v127.671C800.84,439.4,798.191,442.049,794.924,442.049 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M698.962,431.759h-146.98c-2.868,0-5.214-2.346-5.214-5.214V318.765 c0-2.868,2.346-5.214,5.214-5.214h146.98c2.868,0,5.214,2.346,5.214,5.214v107.779 C704.176,429.412,701.83,431.759,698.962,431.759z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M704.176,318.766v2.907H546.77v-2.907c0-2.868,2.343-5.215,5.211-5.215h146.98 C701.829,313.551,704.176,315.898,704.176,318.766z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M551.491,317.612c0-0.787,0.638-1.425,1.425-1.425c0.787,0,1.425,0.638,1.425,1.425 c0,0.787-0.638,1.425-1.425,1.425C552.129,319.037,551.491,318.399,551.491,317.612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M556.629,317.612c0-0.787,0.638-1.425,1.425-1.425s1.425,0.638,1.425,1.425 c0,0.787-0.638,1.425-1.425,1.425S556.629,318.399,556.629,317.612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M561.768,317.612c0-0.787,0.638-1.425,1.425-1.425s1.425,0.638,1.425,1.425 c0,0.787-0.638,1.425-1.425,1.425S561.768,318.399,561.768,317.612z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M581.536,423.017h-27.789c-1.9,0-3.455-1.555-3.455-3.455v-91.096 c0-1.9,1.555-3.455,3.455-3.455h27.789c1.9,0,3.455,1.555,3.455,3.455v91.096C584.99,421.462,583.436,423.017,581.536,423.017 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M559.253,335.064h-5.247c-0.561,0-1.021-0.459-1.021-1.021v-5.247 c0-0.561,0.459-1.021,1.021-1.021h5.247c0.561,0,1.021,0.459,1.021,1.021v5.247 C560.273,334.605,559.814,335.064,559.253,335.064z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M559.253,345.47h-5.247c-0.561,0-1.021-0.459-1.021-1.021v-5.247 c0-0.561,0.459-1.021,1.021-1.021h5.247c0.561,0,1.021,0.459,1.021,1.021v5.247 C560.273,345.011,559.814,345.47,559.253,345.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M559.253,355.876h-5.247c-0.561,0-1.021-0.459-1.021-1.021v-5.247 c0-0.561,0.459-1.021,1.021-1.021h5.247c0.561,0,1.021,0.459,1.021,1.021v5.247 C560.273,355.417,559.814,355.876,559.253,355.876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M559.253,366.282h-5.247c-0.561,0-1.021-0.459-1.021-1.021v-5.247 c0-0.561,0.459-1.021,1.021-1.021h5.247c0.561,0,1.021,0.459,1.021,1.021v5.247 C560.273,365.823,559.814,366.282,559.253,366.282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M559.253,376.688h-5.247c-0.561,0-1.021-0.459-1.021-1.021v-5.247 c0-0.561,0.459-1.021,1.021-1.021h5.247c0.561,0,1.021,0.459,1.021,1.021v5.247 C560.273,376.229,559.814,376.688,559.253,376.688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M559.253,387.094h-5.247c-0.561,0-1.021-0.459-1.021-1.021v-5.247 c0-0.561,0.459-1.021,1.021-1.021h5.247c0.561,0,1.021,0.459,1.021,1.021v5.247 C560.273,386.635,559.814,387.094,559.253,387.094z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M559.253,397.5h-5.247c-0.561,0-1.021-0.459-1.021-1.021v-5.247 c0-0.561,0.459-1.021,1.021-1.021h5.247c0.561,0,1.021,0.459,1.021,1.021v5.247 C560.273,397.041,559.814,397.5,559.253,397.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M559.253,407.906h-5.247c-0.561,0-1.021-0.459-1.021-1.021v-5.247 c0-0.561,0.459-1.021,1.021-1.021h5.247c0.561,0,1.021,0.459,1.021,1.021v5.247 C560.273,407.447,559.814,407.906,559.253,407.906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M559.253,418.313h-5.247c-0.561,0-1.021-0.459-1.021-1.021v-5.247 c0-0.561,0.459-1.021,1.021-1.021h5.247c0.561,0,1.021,0.459,1.021,1.021v5.247 C560.273,417.853,559.814,418.313,559.253,418.313z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M576.701,330.393h-12.427c-0.595,0-1.081-0.486-1.081-1.081l0,0 c0-0.595,0.486-1.081,1.081-1.081h12.427c0.594,0,1.081,0.486,1.081,1.081l0,0 C577.781,329.907,577.295,330.393,576.701,330.393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M576.701,334.609h-12.427c-0.595,0-1.081-0.486-1.081-1.081l0,0 c0-0.594,0.486-1.081,1.081-1.081h12.427c0.594,0,1.081,0.486,1.081,1.081l0,0 C577.781,334.122,577.295,334.609,576.701,334.609z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M576.701,340.799h-12.427c-0.595,0-1.081-0.486-1.081-1.081l0,0 c0-0.595,0.486-1.081,1.081-1.081h12.427c0.594,0,1.081,0.486,1.081,1.081l0,0 C577.781,340.313,577.295,340.799,576.701,340.799z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M571.316,345.015h-7.043c-0.595,0-1.081-0.486-1.081-1.081l0,0 c0-0.594,0.486-1.081,1.081-1.081h7.043c0.595,0,1.081,0.486,1.081,1.081l0,0 C572.397,344.529,571.911,345.015,571.316,345.015z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M576.701,351.205h-12.427c-0.595,0-1.081-0.486-1.081-1.081l0,0 c0-0.595,0.486-1.081,1.081-1.081h12.427c0.594,0,1.081,0.486,1.081,1.081l0,0 C577.781,350.719,577.295,351.205,576.701,351.205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M576.701,355.421h-12.427c-0.595,0-1.081-0.486-1.081-1.081l0,0 c0-0.594,0.486-1.081,1.081-1.081h12.427c0.594,0,1.081,0.486,1.081,1.081l0,0 C577.781,354.935,577.295,355.421,576.701,355.421z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M567.616,361.611h-3.343c-0.597,0-1.081-0.484-1.081-1.081l0,0 c0-0.597,0.484-1.081,1.081-1.081h3.343c0.597,0,1.081,0.484,1.081,1.081l0,0 C568.697,361.127,568.213,361.611,567.616,361.611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M574.67,361.611h-3.343c-0.597,0-1.081-0.484-1.081-1.081l0,0 c0-0.597,0.484-1.081,1.081-1.081h3.343c0.597,0,1.081,0.484,1.081,1.081l0,0 C575.751,361.127,575.267,361.611,574.67,361.611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M576.701,365.827h-12.427c-0.595,0-1.081-0.486-1.081-1.081l0,0 c0-0.594,0.486-1.081,1.081-1.081h12.427c0.594,0,1.081,0.487,1.081,1.081l0,0 C577.781,365.341,577.295,365.827,576.701,365.827z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M567.616,403.236h-3.343c-0.597,0-1.081-0.484-1.081-1.081l0,0 c0-0.597,0.484-1.081,1.081-1.081h3.343c0.597,0,1.081,0.484,1.081,1.081l0,0 C568.697,402.752,568.213,403.236,567.616,403.236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M574.67,403.236h-3.343c-0.597,0-1.081-0.484-1.081-1.081l0,0 c0-0.597,0.484-1.081,1.081-1.081h3.343c0.597,0,1.081,0.484,1.081,1.081l0,0 C575.751,402.752,575.267,403.236,574.67,403.236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M576.701,407.451h-12.427c-0.595,0-1.081-0.486-1.081-1.081l0,0 c0-0.595,0.486-1.081,1.081-1.081h12.427c0.594,0,1.081,0.487,1.081,1.081l0,0 C577.781,406.965,577.295,407.451,576.701,407.451z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M576.701,372.017h-12.427c-0.595,0-1.081-0.486-1.081-1.081l0,0 c0-0.595,0.486-1.081,1.081-1.081h12.427c0.594,0,1.081,0.486,1.081,1.081l0,0 C577.781,371.531,577.295,372.017,576.701,372.017z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M576.701,376.233h-12.427c-0.595,0-1.081-0.486-1.081-1.081v0 c0-0.594,0.486-1.081,1.081-1.081h12.427c0.594,0,1.081,0.486,1.081,1.081v0 C577.781,375.747,577.295,376.233,576.701,376.233z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M576.701,382.423h-12.427c-0.595,0-1.081-0.486-1.081-1.081l0,0 c0-0.595,0.486-1.081,1.081-1.081h12.427c0.594,0,1.081,0.486,1.081,1.081l0,0 C577.781,381.937,577.295,382.423,576.701,382.423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M571.856,386.639h-7.582c-0.595,0-1.081-0.487-1.081-1.081l0,0 c0-0.594,0.486-1.081,1.081-1.081h7.582c0.594,0,1.081,0.486,1.081,1.081l0,0 C572.937,386.153,572.45,386.639,571.856,386.639z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M576.701,392.829h-12.427c-0.595,0-1.081-0.486-1.081-1.081v0 c0-0.595,0.486-1.081,1.081-1.081h12.427c0.594,0,1.081,0.486,1.081,1.081v0 C577.781,392.343,577.295,392.829,576.701,392.829z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M576.701,397.045h-12.427c-0.595,0-1.081-0.486-1.081-1.081l0,0 c0-0.594,0.486-1.081,1.081-1.081h12.427c0.594,0,1.081,0.486,1.081,1.081l0,0 C577.781,396.559,577.295,397.045,576.701,397.045z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M576.701,413.642h-12.427c-0.595,0-1.081-0.486-1.081-1.081l0,0 c0-0.595,0.486-1.081,1.081-1.081h12.427c0.594,0,1.081,0.486,1.081,1.081l0,0 C577.781,413.155,577.295,413.642,576.701,413.642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M576.701,417.858h-12.427c-0.595,0-1.081-0.486-1.081-1.081v0 c0-0.594,0.486-1.081,1.081-1.081h12.427c0.594,0,1.081,0.486,1.081,1.081v0 C577.781,417.371,577.295,417.858,576.701,417.858z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M591.532,413.642L591.532,413.642c-0.588,0-1.069-0.481-1.069-1.069V326.08 c0-0.588,0.481-1.069,1.069-1.069l0,0c0.588,0,1.069,0.481,1.069,1.069v86.493C592.601,413.161,592.12,413.642,591.532,413.642 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M649.062,364.38h-18.438c-0.672,0-1.223-0.55-1.223-1.223l0,0 c0-0.673,0.55-1.223,1.223-1.223h18.438c0.672,0,1.223,0.55,1.223,1.223l0,0C650.285,363.83,649.735,364.38,649.062,364.38z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M611.124,364.38h-10.888c-0.673,0-1.223-0.55-1.223-1.223l0,0 c0-0.673,0.55-1.223,1.223-1.223h10.888c0.672,0,1.223,0.55,1.223,1.223l0,0C612.347,363.83,611.797,364.38,611.124,364.38z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M626.131,364.38h-10.888c-0.672,0-1.223-0.55-1.223-1.223l0,0 c0-0.673,0.55-1.223,1.223-1.223h10.888c0.672,0,1.223,0.55,1.223,1.223l0,0C627.354,363.83,626.803,364.38,626.131,364.38z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M618.674,352.263h-18.438c-0.673,0-1.223-0.55-1.223-1.223l0,0 c0-0.673,0.55-1.223,1.223-1.223h18.438c0.672,0,1.223,0.55,1.223,1.223l0,0 C619.897,351.713,619.347,352.263,618.674,352.263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M643.417,352.263h-10.888c-0.672,0-1.223-0.55-1.223-1.223l0,0 c0-0.673,0.55-1.223,1.223-1.223h10.888c0.672,0,1.223,0.55,1.223,1.223l0,0 C644.639,351.713,644.089,352.263,643.417,352.263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M658.423,352.263h-10.888c-0.672,0-1.223-0.55-1.223-1.223l0,0 c0-0.673,0.55-1.223,1.223-1.223h10.888c0.672,0,1.223,0.55,1.223,1.223l0,0 C659.646,351.713,659.096,352.263,658.423,352.263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M628.179,352.263h-5.571c-0.673,0-1.223-0.55-1.223-1.223l0,0 c0-0.673,0.55-1.223,1.223-1.223h5.571c0.673,0,1.223,0.55,1.223,1.223l0,0 C629.402,351.713,628.851,352.263,628.179,352.263z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M621.045,376.608h-10.888c-0.672,0-1.223-0.55-1.223-1.223l0,0 c0-0.672,0.55-1.223,1.223-1.223h10.888c0.672,0,1.223,0.55,1.223,1.223l0,0 C622.268,376.057,621.718,376.608,621.045,376.608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M605.808,376.608h-5.571c-0.673,0-1.223-0.55-1.223-1.223l0,0 c0-0.672,0.55-1.223,1.223-1.223h5.571c0.673,0,1.223,0.55,1.223,1.223l0,0C607.031,376.057,606.48,376.608,605.808,376.608 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M631.261,376.608h-5.571c-0.672,0-1.223-0.55-1.223-1.223l0,0 c0-0.672,0.55-1.223,1.223-1.223h5.571c0.672,0,1.223,0.55,1.223,1.223l0,0 C632.483,376.057,631.933,376.608,631.261,376.608z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M634.056,388.835h-18.438c-0.673,0-1.223-0.55-1.223-1.223l0,0 c0-0.672,0.55-1.223,1.223-1.223h18.438c0.672,0,1.223,0.55,1.223,1.223l0,0 C635.278,388.285,634.728,388.835,634.056,388.835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M611.124,388.835h-10.888c-0.673,0-1.223-0.55-1.223-1.223l0,0 c0-0.672,0.55-1.223,1.223-1.223h10.888c0.672,0,1.223,0.55,1.223,1.223l0,0 C612.347,388.285,611.797,388.835,611.124,388.835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M645.067,388.835h-5.572c-0.672,0-1.223-0.55-1.223-1.223l0,0 c0-0.672,0.55-1.223,1.223-1.223h5.572c0.672,0,1.223,0.55,1.223,1.223l0,0 C646.289,388.285,645.739,388.835,645.067,388.835z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M649.086,358.266h-48.849c-0.673,0-1.223-0.55-1.223-1.223l0,0 c0-0.673,0.55-1.223,1.223-1.223h48.849c0.672,0,1.223,0.55,1.223,1.223l0,0 C650.308,357.716,649.758,358.266,649.086,358.266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M649.086,382.721h-48.849c-0.673,0-1.223-0.55-1.223-1.223l0,0 c0-0.672,0.55-1.223,1.223-1.223h48.849c0.672,0,1.223,0.55,1.223,1.223l0,0 C650.308,382.171,649.758,382.721,649.086,382.721z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M638.898,370.494h-5.571c-0.673,0-1.223-0.55-1.223-1.223l0,0 c0-0.673,0.55-1.223,1.223-1.223h5.571c0.672,0,1.223,0.55,1.223,1.223l0,0C640.12,369.944,639.57,370.494,638.898,370.494z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M654.225,370.494h-10.888c-0.673,0-1.223-0.55-1.223-1.223l0,0 c0-0.673,0.55-1.223,1.223-1.223h10.888c0.673,0,1.223,0.55,1.223,1.223l0,0 C655.448,369.944,654.897,370.494,654.225,370.494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M628.916,370.494h-28.679c-0.673,0-1.223-0.55-1.223-1.223l0,0 c0-0.673,0.55-1.223,1.223-1.223h28.679c0.673,0,1.223,0.55,1.223,1.223l0,0 C630.139,369.944,629.588,370.494,628.916,370.494z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M688.605,335.064H604.04c-2.764,0-5.026-2.262-5.026-5.026l0,0 c0-2.764,2.262-5.026,5.026-5.026h84.565c2.764,0,5.026,2.262,5.026,5.026l0,0 C693.631,332.802,691.37,335.064,688.605,335.064z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D9DBEE"
    },
    cx: 604.527,
    cy: 329.365,
    r: 2.762
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M602.693,329.365c0-1.013,0.821-1.834,1.834-1.834c1.013,0,1.834,0.821,1.834,1.834 c0,1.013-0.821,1.834-1.834,1.834C603.514,331.199,602.693,330.378,602.693,329.365z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M608.956,333.657l-0.032,0.036c-0.187,0.209-0.512,0.227-0.721,0.039l-2.33-2.089 c-0.209-0.187-0.227-0.512-0.039-0.721l0.032-0.036c0.187-0.209,0.512-0.227,0.721-0.039l2.33,2.089 C609.125,333.124,609.143,333.448,608.956,333.657z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M599.013,342.082c0-1.476,1.197-2.673,2.673-2.673c1.476,0,2.673,1.197,2.673,2.673 c0,1.476-1.197,2.673-2.673,2.673C600.21,344.754,599.013,343.558,599.013,342.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M607.031,342.082c0-1.476,1.197-2.673,2.673-2.673c1.476,0,2.673,1.197,2.673,2.673 c0,1.476-1.197,2.673-2.673,2.673C608.227,344.754,607.031,343.558,607.031,342.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M615.047,342.082c0-1.476,1.197-2.673,2.673-2.673c1.476,0,2.673,1.197,2.673,2.673 c0,1.476-1.197,2.673-2.673,2.673C616.244,344.754,615.047,343.558,615.047,342.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M623.064,342.082c0-1.476,1.197-2.673,2.673-2.673s2.673,1.197,2.673,2.673 c0,1.476-1.197,2.673-2.673,2.673S623.064,343.558,623.064,342.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M631.081,342.082c0-1.476,1.197-2.673,2.673-2.673c1.476,0,2.673,1.197,2.673,2.673 c0,1.476-1.197,2.673-2.673,2.673C632.278,344.754,631.081,343.558,631.081,342.082z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M785.145,356.435h-68.443c-2.822,0-5.13-2.308-5.13-5.13v-32.766c0-2.821,2.308-5.13,5.13-5.13 h68.443c2.821,0,5.13,2.308,5.13,5.13v32.766C790.275,354.127,787.966,356.435,785.145,356.435z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M790.274,318.539v2.992h-78.701v-2.992c0-2.822,2.308-5.13,5.13-5.13h68.441 C787.965,313.409,790.274,315.718,790.274,318.539z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M715.56,317.47c0-0.787,0.638-1.425,1.425-1.425c0.787,0,1.425,0.638,1.425,1.425 c0,0.787-0.638,1.425-1.425,1.425C716.198,318.895,715.56,318.257,715.56,317.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M720.698,317.47c0-0.787,0.638-1.425,1.425-1.425c0.787,0,1.425,0.638,1.425,1.425 c0,0.787-0.638,1.425-1.425,1.425C721.336,318.895,720.698,318.257,720.698,317.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M725.837,317.47c0-0.787,0.638-1.425,1.425-1.425c0.787,0,1.425,0.638,1.425,1.425 c0,0.787-0.638,1.425-1.425,1.425C726.475,318.895,725.837,318.257,725.837,317.47z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M724.205,351.327L724.205,351.327c-0.959,0-1.744-0.785-1.744-1.744v-21.759 c0-0.959,0.785-1.744,1.744-1.744l0,0c0.959,0,1.744,0.785,1.744,1.744v21.759 C725.949,350.542,725.164,351.327,724.205,351.327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M727.22,336.779h-6.031c-0.952,0-1.731-0.779-1.731-1.731l0,0c0-0.952,0.779-1.731,1.731-1.731 h6.031c0.952,0,1.731,0.779,1.731,1.731l0,0C728.952,336,728.173,336.779,727.22,336.779z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M737.457,351.327L737.457,351.327c-0.959,0-1.744-0.785-1.744-1.744v-21.759 c0-0.959,0.785-1.744,1.744-1.744l0,0c0.959,0,1.744,0.785,1.744,1.744v21.759 C739.201,350.542,738.416,351.327,737.457,351.327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M740.473,341.053h-6.031c-0.952,0-1.731-0.779-1.731-1.731l0,0 c0-0.952,0.779-1.731,1.731-1.731h6.031c0.952,0,1.731,0.779,1.731,1.731l0,0 C742.204,340.275,741.425,341.053,740.473,341.053z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M750.709,351.327L750.709,351.327c-0.959,0-1.744-0.785-1.744-1.744v-21.759 c0-0.959,0.785-1.744,1.744-1.744l0,0c0.959,0,1.744,0.785,1.744,1.744v21.759 C752.453,350.542,751.669,351.327,750.709,351.327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M753.725,333.786h-6.031c-0.952,0-1.731-0.779-1.731-1.731l0,0 c0-0.952,0.779-1.731,1.731-1.731h6.031c0.952,0,1.731,0.779,1.731,1.731l0,0 C755.456,333.007,754.677,333.786,753.725,333.786z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M763.962,351.327L763.962,351.327c-0.959,0-1.744-0.785-1.744-1.744v-21.759 c0-0.959,0.785-1.744,1.744-1.744l0,0c0.959,0,1.744,0.785,1.744,1.744v21.759 C765.706,350.542,764.921,351.327,763.962,351.327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M766.977,347.038h-6.031c-0.952,0-1.731-0.779-1.731-1.731l0,0 c0-0.952,0.779-1.731,1.731-1.731h6.031c0.952,0,1.731,0.779,1.731,1.731l0,0 C768.708,346.259,767.929,347.038,766.977,347.038z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M777.641,351.327L777.641,351.327c-0.959,0-1.744-0.785-1.744-1.744v-21.759 c0-0.959,0.785-1.744,1.744-1.744l0,0c0.959,0,1.744,0.785,1.744,1.744v21.759 C779.385,350.542,778.601,351.327,777.641,351.327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M780.657,333.786h-6.031c-0.952,0-1.731-0.779-1.731-1.731l0,0 c0-0.952,0.779-1.731,1.731-1.731h6.031c0.952,0,1.731,0.779,1.731,1.731l0,0 C782.388,333.007,781.609,333.786,780.657,333.786z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M785.521,431.759h-68.808c-2.732,0-4.968-2.236-4.968-4.968V371.1 c0-2.732,2.236-4.968,4.968-4.968h68.808c2.732,0,4.968,2.235,4.968,4.968v55.691 C790.488,429.523,788.253,431.759,785.521,431.759z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DBEE"
    },
    d: "M790.487,371.099v3.061h-78.744v-3.061c0-2.732,2.236-4.967,4.972-4.967h68.805 C788.251,366.132,790.487,368.368,790.487,371.099z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M715.576,370.494c0-0.787,0.638-1.425,1.425-1.425c0.787,0,1.425,0.638,1.425,1.425 c0,0.787-0.638,1.425-1.425,1.425C716.214,371.919,715.576,371.281,715.576,370.494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M720.714,370.494c0-0.787,0.638-1.425,1.425-1.425s1.425,0.638,1.425,1.425 c0,0.787-0.638,1.425-1.425,1.425S720.714,371.281,720.714,370.494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8B9D5"
    },
    d: "M725.853,370.494c0-0.787,0.638-1.425,1.425-1.425c0.787,0,1.425,0.638,1.425,1.425 c0,0.787-0.638,1.425-1.425,1.425C726.491,371.919,725.853,371.281,725.853,370.494z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M719.492,381.499h-2.663c-0.672,0-1.223-0.55-1.223-1.223v0c0-0.672,0.55-1.223,1.223-1.223 h2.663c0.672,0,1.223,0.55,1.223,1.223v0C720.714,380.948,720.164,381.499,719.492,381.499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M719.492,386.949h-2.663c-0.672,0-1.223-0.55-1.223-1.223v0c0-0.672,0.55-1.223,1.223-1.223 h2.663c0.672,0,1.223,0.55,1.223,1.223v0C720.714,386.399,720.164,386.949,719.492,386.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M719.492,392.4h-2.663c-0.672,0-1.223-0.55-1.223-1.223v0c0-0.672,0.55-1.223,1.223-1.223h2.663 c0.672,0,1.223,0.55,1.223,1.223v0C720.714,391.849,720.164,392.4,719.492,392.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M719.492,397.85h-2.663c-0.672,0-1.223-0.55-1.223-1.223v0c0-0.672,0.55-1.223,1.223-1.223 h2.663c0.672,0,1.223,0.55,1.223,1.223v0C720.714,397.3,720.164,397.85,719.492,397.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M719.492,403.301h-2.663c-0.672,0-1.223-0.55-1.223-1.223v0c0-0.672,0.55-1.223,1.223-1.223 h2.663c0.672,0,1.223,0.55,1.223,1.223v0C720.714,402.75,720.164,403.301,719.492,403.301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M719.492,408.751h-2.663c-0.672,0-1.223-0.55-1.223-1.223v0c0-0.672,0.55-1.223,1.223-1.223 h2.663c0.672,0,1.223,0.55,1.223,1.223v0C720.714,408.201,720.164,408.751,719.492,408.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M719.492,414.202h-2.663c-0.672,0-1.223-0.55-1.223-1.223v0c0-0.672,0.55-1.223,1.223-1.223 h2.663c0.672,0,1.223,0.55,1.223,1.223v0C720.714,413.651,720.164,414.202,719.492,414.202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M719.492,419.652h-2.663c-0.672,0-1.223-0.55-1.223-1.223v0c0-0.672,0.55-1.223,1.223-1.223 h2.663c0.672,0,1.223,0.55,1.223,1.223v0C720.714,419.102,720.164,419.652,719.492,419.652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M719.492,425.103h-2.663c-0.672,0-1.223-0.55-1.223-1.223v0c0-0.672,0.55-1.223,1.223-1.223 h2.663c0.672,0,1.223,0.55,1.223,1.223v0C720.714,424.552,720.164,425.103,719.492,425.103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M734.147,392.4h-10.888c-0.672,0-1.223-0.55-1.223-1.223l0,0c0-0.673,0.55-1.223,1.223-1.223 h10.888c0.672,0,1.223,0.55,1.223,1.223l0,0C735.37,391.849,734.819,392.4,734.147,392.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M734.147,397.85h-10.888c-0.672,0-1.223-0.55-1.223-1.223l0,0c0-0.673,0.55-1.223,1.223-1.223 h10.888c0.672,0,1.223,0.55,1.223,1.223l0,0C735.37,397.3,734.819,397.85,734.147,397.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M734.147,419.652h-10.888c-0.672,0-1.223-0.55-1.223-1.223l0,0c0-0.673,0.55-1.223,1.223-1.223 h10.888c0.672,0,1.223,0.55,1.223,1.223l0,0C735.37,419.102,734.819,419.652,734.147,419.652z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#995C7D"
    },
    d: "M327.694,502.545h8.312c2.93,0,5.328-2.398,5.328-5.331v-14.881c0-2.93-2.398-5.328-5.328-5.328 h-8.476c-0.05-1.498-0.086-2.996-0.099-4.493h11.804c3.823,0,6.951,3.128,6.951,6.951v20.626c0,3.823-3.128,6.951-6.951,6.951 h-12.132C327.355,505.543,327.548,504.045,327.694,502.545z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7A3D5F"
    },
    d: "M331.937,466.757v45.342c0,2.328-1.641,4.236-3.644,4.236h-33.372 c-2.003,0-3.644-1.908-3.644-4.236v-45.342c0-2.332,1.641-4.236,3.644-4.236h33.372 C330.295,462.52,331.937,464.425,331.937,466.757z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#995C7D"
    },
    d: "M332.521,466.757v45.342c0,2.328-1.641,4.236-3.645,4.236h-23.505 c-2.003,0-3.644-1.908-3.644-4.236v-45.342c0-2.332,1.641-4.236,3.644-4.236h23.505 C330.879,462.52,332.521,464.425,332.521,466.757z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4EB3AF"
    },
    d: "M922.798,347.75c-13.835,25.287-18.947,54.953-14.466,83.42c0.375,2.38,4.087,1.866,3.711-0.522 c-4.389-27.879,0.679-56.723,14.222-81.476C927.424,347.056,923.943,345.656,922.798,347.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE989"
    },
    d: "M940.709,341.898c0.67-1.034,1.163-2.16,1.284-3.392c0.228-2.307-1.056-4.406-3.196-5.268 c-3.75-1.511-6.797,0.534-9.093,3.259c-0.807-2.34-2.093-4.527-4.25-5.864c-2.276-1.41-5.348-1.578-7.713-0.281 c-3.142,1.722-3.758,5.852-2.085,8.538c-2.037,0.19-4.036,0.636-5.81,1.715c-2.284,1.389-4.014,3.959-3.986,6.69 c0.028,2.716,1.942,4.863,4.455,5.694c2.234,0.738,4.477,0.425,6.646-0.241c-1.399,5.165,2.086,10.965,8.015,11.207 c5.367,0.22,9.336-4.378,9.142-9.239c0.14-0.409,0.262-0.825,0.357-1.253c1.849,0.421,3.766,0.459,5.593-0.188 c2.421-0.857,4.479-3.137,4.765-5.734C945.138,344.761,943.092,342.477,940.709,341.898z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2B263"
    },
    d: "M927.787,341.902c-1.796,0-3.481,0.928-3.732,2.873c-0.207,1.603,1.063,3.733,2.873,3.733 c1.796,0,3.481-0.928,3.732-2.873C930.867,344.031,929.597,341.902,927.787,341.902z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F27792"
    },
    cx: 908.777,
    cy: 474.105,
    rx: 27.572,
    ry: 38.518
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F27792"
    },
    d: "M916.624,402.253v60.154c0,4.437-2.6,8.069-5.776,8.069h-4.146 c-3.176,0-5.771-3.632-5.771-8.069v-60.154c0-4.437,2.595-8.069,5.771-8.069h4.146 C914.024,394.184,916.624,397.816,916.624,402.253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D74C6B"
    },
    d: "M927.399,508.459c0,0.785-0.089,1.544-0.248,2.264c-0.267,1.171-0.731,2.219-1.34,3.076 c-0.984,1.368-2.338,2.219-3.823,2.219h-26.425c-2.413,0-4.464-2.238-5.158-5.294c-0.159-0.72-0.248-1.479-0.248-2.264 c0-2.081,0.609-3.966,1.588-5.333s2.328-2.219,3.818-2.219h26.425C924.963,500.907,927.399,504.303,927.399,508.459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F27792"
    },
    d: "M916.823,403.926H900.73c-3.111,0-5.656-2.545-5.656-5.656v-2.058 c0-3.111,2.545-5.656,5.656-5.656h16.092c3.111,0,5.656,2.545,5.656,5.656v2.058 C922.479,401.381,919.933,403.926,916.823,403.926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F27792"
    },
    d: "M927.399,508.459c0,0.785-0.089,1.544-0.248,2.264h-36.745c-0.159-0.72-0.248-1.479-0.248-2.264 c0-2.081,0.609-3.966,1.588-5.333s2.328-2.219,3.818-2.219h26.425C924.963,500.907,927.399,504.303,927.399,508.459z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 900.932,
    y: 403.928,
    style: {
      fill: "#D74C6B"
    },
    width: 15.693,
    height: 4.699
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D74C6B"
    },
    d: "M901.709,509.491c-0.792-7.273-0.738-14.694-0.691-22.033 c0.071-10.985,0.987-21.914,2.112-32.774c0.649-6.266,1.384-12.513,2.081-18.767c-13.542,2.444-24.007,18.603-24.007,38.187 c0,17.983,8.822,33.086,20.75,37.328C901.864,510.785,901.779,510.137,901.709,509.491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D74C6B"
    },
    d: "M903.131,454.685c1.136-10.96,2.537-21.863,3.529-32.852c0.832-9.214,1.432-18.526,0.244-27.649 h-0.202c-3.176,0-5.771,3.632-5.771,8.069v60.154c0,1.713,0.39,3.303,1.048,4.614 C902.311,462.899,902.705,458.787,903.131,454.685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D74C6B"
    },
    d: "M901.709,509.491c-0.309-2.844-0.487-5.71-0.589-8.585h-5.557c-1.49,0-2.839,0.851-3.818,2.219 c-0.979,1.368-1.588,3.252-1.588,5.333c0,0.785,0.089,1.544,0.248,2.264c0.693,3.056,2.745,5.294,5.158,5.294h7.24 C902.302,513.883,901.947,511.673,901.709,509.491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D74C6B"
    },
    d: "M906.33,390.556h-6.47c-2.632,0-4.785,3.008-4.785,6.685s2.153,6.685,4.785,6.685h7.704 C907.509,399.438,907.154,394.97,906.33,390.556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D74C6B"
    },
    d: "M901.709,509.491c-0.309-2.844-0.487-5.71-0.589-8.585h-5.557c-1.49,0-2.839,0.851-3.818,2.219 c-0.979,1.368-1.588,3.252-1.588,5.333c0,0.785,0.089,1.544,0.248,2.264h11.452 C901.804,510.312,901.754,509.901,901.709,509.491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D74C6B"
    },
    d: "M907.564,403.928h-6.633v4.699h6.59C907.566,407.059,907.584,405.492,907.564,403.928z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M876.651,504.219l-3.434,0.445c-0.677,0.088-1.312-0.467-1.412-1.24l-9.457-72.909 c-0.063-0.486,0.39-6.022,0.734-10.036c0.196-2.345,0.358-4.166,0.358-4.166s0.638,1.717,1.448,3.931 c1.39,3.79,3.286,9.021,3.349,9.507l9.457,72.909C877.795,503.434,877.322,504.132,876.651,504.219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2B263"
    },
    d: "M877.896,504.212l-9.618-74.153l-5.887,0.764l9.618,74.153c0.111,0.855,0.901,1.463,1.755,1.352 l2.779-0.361C877.398,505.856,878.006,505.066,877.896,504.212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F27792"
    },
    d: "M877.933,504.5l-0.408-3.146l-5.887,0.764l0.408,3.146c0.202,1.56,1.644,2.671,3.204,2.469 l0.214-0.028C877.024,507.503,878.135,506.061,877.933,504.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#403E55"
    },
    d: "M877.637,502.218l-0.112-0.864l-5.887,0.763l0.112,0.864c0.013,0.1,0.106,0.172,0.207,0.159 l5.521-0.716C877.578,502.412,877.65,502.319,877.637,502.218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#403E55"
    },
    d: "M864.889,420.245l-1.806,0.234c0.196-2.345,0.358-4.166,0.358-4.166 S864.078,418.031,864.889,420.245z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M881.847,429.994l3.192,0.642c0.629,0.126,1.027,0.812,0.882,1.531l-13.623,67.773 c-0.091,0.452-2.168,5.243-3.688,8.714c-0.884,2.029-1.578,3.601-1.578,3.601s-0.049-1.721-0.101-3.938 c-0.092-3.794-0.198-9.025-0.107-9.477l13.623-67.773C880.591,430.347,881.223,429.868,881.847,429.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2B263"
    },
    d: "M880.736,429.624l-13.855,68.93l5.472,1.1l13.855-68.93c0.16-0.794-0.36-1.575-1.154-1.735 l-2.584-0.519C881.677,428.31,880.896,428.83,880.736,429.624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F27792"
    },
    d: "M880.79,429.356l-0.588,2.925l5.472,1.1l0.588-2.925c0.292-1.45-0.656-2.875-2.107-3.167 l-0.199-0.04C882.507,426.958,881.082,427.906,880.79,429.356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#403E55"
    },
    d: "M880.364,431.477l-0.161,0.803l5.472,1.1l0.161-0.803c0.019-0.094-0.042-0.185-0.136-0.204 l-5.132-1.032C880.474,431.323,880.383,431.384,880.364,431.477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#403E55"
    },
    d: "M866.931,508.316l1.679,0.337c-0.884,2.029-1.578,3.601-1.578,3.601 S866.983,510.532,866.931,508.316z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#403E55"
    },
    d: "M864.056,494.337L864.056,494.337c-0.265,0.016-0.495-0.187-0.511-0.451l-0.611-9.898 c-0.016-0.265,0.187-0.495,0.451-0.511l0,0c0.265-0.016,0.494,0.187,0.511,0.452l0.611,9.898 C864.524,494.091,864.321,494.321,864.056,494.337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78DBBE"
    },
    d: "M863.853,491.05L863.853,491.05c-1.361,0.084-2.544-0.961-2.628-2.323l-3.381-54.783 c-0.084-1.361,0.961-2.544,2.323-2.628l0,0c1.362-0.084,2.544,0.961,2.628,2.323l3.381,54.783 C866.26,489.784,865.215,490.966,863.853,491.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78DBBE"
    },
    d: "M860.146,432.651L860.146,432.651c-0.75,0.046-1.401-0.529-1.447-1.279l-0.414-6.699 c-0.046-0.749,0.529-1.401,1.279-1.447l0,0c0.75-0.046,1.401,0.529,1.447,1.279l0.414,6.699 C861.47,431.953,860.895,432.604,860.146,432.651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7A3D5F"
    },
    d: "M864.156,457.752l-4.903,0.303c-0.449,0.028-0.84-0.317-0.868-0.767l-1.699-27.522 c-0.111-1.798,1.269-3.36,3.067-3.471l0,0c1.798-0.111,3.36,1.269,3.471,3.067l1.699,27.522 C864.95,457.334,864.605,457.724,864.156,457.752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78DBBE"
    },
    d: "M863.3,433.993l-6.121,0.378c-0.351,0.022-0.656-0.248-0.678-0.599l-0.016-0.254 c-0.022-0.351,0.248-0.656,0.599-0.678l6.121-0.378c0.351-0.022,0.656,0.248,0.678,0.599l0.016,0.254 C863.921,433.666,863.652,433.971,863.3,433.993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78DBBE"
    },
    d: "M863.436,436.19l-6.121,0.378c-0.351,0.022-0.656-0.248-0.678-0.599l-0.016-0.254 c-0.022-0.351,0.248-0.656,0.599-0.678l6.121-0.378c0.351-0.022,0.656,0.248,0.678,0.599l0.016,0.254 C864.057,435.864,863.787,436.169,863.436,436.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A95BD"
    },
    d: "M888.945,448.035v64.5c0,2.061-1.686,3.747-3.747,3.747h-27.751 c-2.061,0-3.748-1.686-3.748-3.747v-64.5c0-2.061,1.686-3.748,3.748-3.748h27.751 C887.258,444.287,888.945,445.973,888.945,448.035z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ABFDB"
    },
    d: "M888.945,448.035v64.5c0,2.061-1.686,3.747-3.747,3.747H864.16v-71.995h21.038 C887.258,444.287,888.945,445.973,888.945,448.035z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB947B"
    },
    d: "M507.995,397.5h-25.502c-3.092,0-5.621-2.53-5.621-5.621v-53.298c0-3.092,2.53-5.621,5.621-5.621 h25.502c3.092,0,5.621,2.53,5.621,5.621v53.298C513.616,394.971,511.087,397.5,507.995,397.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E46758"
    },
    d: "M513.619,369.336v14.288c-12.69-4.928-34.874-26.561-36.745-36.693v-8.348 c0-1.265,0.426-2.441,1.138-3.382c2.502,4.825,4.403,7.809,4.403,7.809l1.841,2.103 C487.625,354.777,500.863,364.431,513.619,369.336z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB947B"
    },
    d: "M529.486,372.655c-14.827,0.389-40.358-13.562-45.228-27.541l-1.844-2.105 c0,0-31.178-48.849-6.913-70.815c5.621-5.087,14.587-4.141,22.167-4.239l8.601-0.112c21.089-0.286,38.539,13.857,38.782,31.419 l0.164,12.137l0.23,17.084C545.445,328.483,545.27,372.24,529.486,372.655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M476.963,338.241c0,0-0.089,0.094-0.117,0.084c-0.033-0.009-0.052-0.019-0.061-0.028 c-0.009-0.009,0-0.019,0.023-0.028C476.836,338.259,476.888,338.245,476.963,338.241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB947B"
    },
    d: "M543.66,319.528c6.926,4.504,10.942,10.612,8.972,13.642c-1.971,3.03-9.182,1.834-16.108-2.67 c-6.925-4.504-10.942-10.612-8.972-13.642C529.522,313.828,536.734,315.024,543.66,319.528z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191B2A"
    },
    d: "M479.811,268.529c0,0-22.153-0.074-26.858,2.916c-7.37,4.684-10.645,13.376-8.796,21.427 c0.002,0.023,0.002,0.044,0.004,0.068l0.046,0.135c0.279,1.157,0.659,2.301,1.153,3.416l10.43,30.908 c2.292,14.689,12.144,20.606,21.374,20.51c0,0,16.485-0.908,16.971-20.874l2.674-35.06 C496.689,278.984,489.041,268.433,479.811,268.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB947B"
    },
    d: "M531.948,346.888l12.443,1.49c1.528,0.183,2.929-0.917,3.114-2.444l0,0 c0.185-1.527-0.914-2.926-2.441-3.109l-12.443-1.49c-1.528-0.183-2.929,0.917-3.114,2.444l0,0 C529.321,345.306,530.42,346.705,531.948,346.888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB947B"
    },
    d: "M530.296,351.478l12.443,1.49c1.528,0.183,2.929-0.917,3.114-2.444h0 c0.185-1.527-0.914-2.926-2.441-3.109l-12.443-1.49c-1.528-0.183-2.929,0.917-3.114,2.444l0,0 C527.67,349.896,528.768,351.295,530.296,351.478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191B2A"
    },
    d: "M490.599,319.125h-7.647c-4.051,0-7.366-3.315-7.366-7.366v-45.745 c0-4.051,3.315-7.366,7.366-7.366h14.3c4.051,0,7.366,3.315,7.366,7.366v39.092 C504.617,312.816,498.309,319.125,490.599,319.125z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M543.316,312.161c0.7-4.437-2.33-8.601-6.767-9.301c-4.437-0.7-8.601,2.33-9.301,6.767 c-0.7,4.437,2.33,8.601,6.767,9.301C538.452,319.628,542.617,316.598,543.316,312.161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4994F0"
    },
    d: "M543.208,312.702c0.471-2.987-1.569-5.791-4.556-6.262c-2.987-0.471-5.791,1.569-6.262,4.556 c-0.471,2.987,1.569,5.79,4.556,6.262C539.934,317.728,542.737,315.689,543.208,312.702z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002539"
    },
    d: "M542.95,312.659c0.365-2.314-1.215-4.486-3.529-4.851c-2.314-0.365-4.486,1.215-4.851,3.529 c-0.365,2.314,1.215,4.486,3.529,4.851C540.413,316.553,542.585,314.973,542.95,312.659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M534.909,309.862c0.021-0.135,0.597-0.156,1.286-0.047c0.689,0.109,1.23,0.306,1.209,0.441 c-0.021,0.135-0.597,0.156-1.286,0.047C535.429,310.194,534.888,309.997,534.909,309.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M537.92,311.68c0.022-0.14-0.073-0.271-0.213-0.293c-0.14-0.022-0.271,0.073-0.293,0.213 c-0.022,0.14,0.073,0.271,0.213,0.293C537.767,311.915,537.898,311.82,537.92,311.68z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB947B"
    },
    d: "M542.153,310.168l-20.949,2.29c-1.762,0.193-3.36-1.091-3.553-2.853l-0.369-3.377 c-0.193-1.762,1.091-3.36,2.853-3.553l20.949-2.29c1.762-0.193,3.36,1.091,3.553,2.853l0.369,3.377 C545.198,308.377,543.914,309.976,542.153,310.168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191B2A"
    },
    d: "M526.857,305.393l16.637-1.819c1.524-0.167,2.634-1.55,2.468-3.073l-0.048-0.44 c-0.167-1.524-1.55-2.634-3.073-2.467l-16.637,1.819c-1.524,0.167-2.634,1.55-2.468,3.073l0.048,0.44 C523.95,304.449,525.333,305.559,526.857,305.393z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB947B"
    },
    d: "M490.428,333.414l-0.316,0.003c-4.698,0.048-8.575-3.755-8.617-8.449l-0.003-0.316 c-0.042-4.695,3.767-8.575,8.465-8.622l0.316-0.003c4.698-0.048,8.575,3.754,8.617,8.449l0.003,0.316 C498.934,329.486,495.125,333.366,490.428,333.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E46758"
    },
    d: "M490.303,328.812l-0.149,0.002c-2.211,0.022-4.035-1.767-4.055-3.976l-0.001-0.148 c-0.02-2.209,1.773-4.035,3.983-4.058l0.149-0.001c2.211-0.022,4.035,1.767,4.055,3.976l0.001,0.148 C494.306,326.964,492.514,328.79,490.303,328.812z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191B2A"
    },
    d: "M500.623,245.1c-8.211,1.947-16.159,4.612-19.667,5.84c-1.037,0.363-2.08,0.709-3.13,1.032 c-10.807,3.322-17.464,10.803-16.767,21.765l0.252,3.963c0.297,4.666,4.105,8.219,8.462,7.895l73.216,4.105 c0,0,26.982-1.342,22.789-41.005c-0.798,0.523-12.022,4.129-21.092,5.431c-3.713,0.533-8.73-3.182-13.219-5.957 C522.324,242.518,511.085,242.619,500.623,245.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E27E6A"
    },
    d: "M594.24,642.276l10.377,5.124c7.664,3.785,10.838,13.152,7.053,20.815l-47.377,95.941 c-1.239,2.509-4.306,3.548-6.815,2.309l-24.311-12.005l54.258-109.875C588.664,642.077,591.731,641.037,594.24,642.276z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#302E46"
    },
    d: "M602.672,810.937c-0.173,0.397-0.494,0.695-0.866,0.843c-0.374,0.154-0.802,0.165-1.204-0.004 l-76.483-32.683l-10.17-4.344c-1.028-0.438-1.506-1.644-1.065-2.678l5.063-11.852c0.755-1.767,2.094-4.127,3.879-6.256 c0.665-0.801,1.39-1.564,2.174-2.258c3.213-2.838,7.795-3.479,11.708-1.809l51.441,21.981 C602.128,778.28,609.111,795.856,602.672,810.937z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEEDED"
    },
    d: "M600.048,814.586l-88.185-37.06c-1.861-0.782-2.743-2.944-1.961-4.805l0,0 c0.782-1.861,2.944-2.743,4.805-1.961l88.185,37.06c1.861,0.782,2.743,2.944,1.961,4.805v0 C604.07,814.486,601.908,815.368,600.048,814.586z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEEDED"
    },
    d: "M561.937,770.303L561.937,770.303c0.748,0.621,1.873,0.47,2.502-0.337l4.104-5.268 c0.628-0.807,0.531-1.975-0.217-2.596l0,0c-0.747-0.622-1.873-0.47-2.502,0.337l-4.104,5.268 C561.092,768.513,561.189,769.681,561.937,770.303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEEDED"
    },
    d: "M568.554,773.133L568.554,773.133c0.748,0.621,1.873,0.47,2.502-0.337l4.105-5.268 c0.628-0.807,0.531-1.975-0.217-2.596l0,0c-0.748-0.622-1.873-0.47-2.502,0.337l-4.104,5.268 C567.709,771.343,567.807,772.511,568.554,773.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEEDED"
    },
    d: "M575.172,775.963L575.172,775.963c0.748,0.621,1.873,0.47,2.502-0.337l4.105-5.268 c0.628-0.807,0.531-1.975-0.217-2.596l0,0c-0.748-0.621-1.873-0.47-2.502,0.337l-4.104,5.268 C574.327,774.173,574.424,775.341,575.172,775.963z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#302E46"
    },
    d: "M464.208,619.474v-41.445c0-1.466,1.2-2.666,2.666-2.666H634.19 c9.018,0,16.397,7.379,16.397,16.397v8.904c0,11.811-9.664,21.474-21.474,21.474H466.874 C465.407,622.139,464.208,620.94,464.208,619.474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB947B"
    },
    d: "M648.057,654.496l24.44,0.307c2.951,0.037,5.338,2.253,5.304,4.924l-1.558,124.099l-33.958-0.445 l-0.056-123.742C642.265,656.771,644.888,654.456,648.057,654.496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#302E46"
    },
    d: "M536.554,740.893l37.377,18.356c1.267,0.622,2.814,0.095,3.436-1.173l68.116-138.698 c3.829-7.796,0.583-17.308-7.214-21.137l-25.507-12.526c-1.267-0.622-2.814-0.095-3.436,1.173l-73.945,150.569 C534.759,738.724,535.286,740.271,536.554,740.893z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#403E55"
    },
    d: "M487.961,627.6v-43.439c0-1.547,1.265-2.812,2.812-2.812h177.605 c9.513,0,17.296,7.783,17.296,17.296v9.115c0,12.458-10.193,22.652-22.652,22.652h-172.25 C489.226,630.412,487.961,629.147,487.961,627.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#403E55"
    },
    d: "M637.193,765.633l44.179,0.458c1.452,0.015,2.652-1.161,2.667-2.613l1.635-157.588 c0.072-6.954-5.559-12.703-12.513-12.775l-34.175-0.354c-1.452-0.015-2.652,1.161-2.667,2.613l-1.739,167.591 C634.565,764.418,635.741,765.618,637.193,765.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#403E55"
    },
    d: "M465.164,630.6h54.619c8.896,0,16.176-11.053,16.176-24.561l-0.552-44.525h-86.453l0.035,44.525 C448.988,619.547,456.267,630.6,465.164,630.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4EB3AF"
    },
    d: "M445.79,601.555l90.019-20.24c0.784,0.022,1.442-0.809,1.471-1.856l4.251-153.383 c0.751-27.084-15.074-49.496-35.347-50.058l-29.098,0.356c-17.69-0.49-25.095,17.317-25.75,40.952L445.79,601.555z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#403E55"
    },
    d: "M729.939,809.18c-0.006,0.434-0.186,0.832-0.471,1.113c-0.285,0.287-0.675,0.463-1.112,0.463 l-83.172-0.498l-11.059-0.064c-1.117-0.006-2.026-0.932-2.019-2.056l0.076-12.888c0.012-1.922,0.332-4.616,1.152-7.27 c0.303-0.996,0.675-1.98,1.129-2.923c1.863-3.861,5.838-6.227,10.092-6.204l55.939,0.334 C716.785,779.285,730.032,792.782,729.939,809.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFEFF"
    },
    d: "M728.934,813.561h-95.656c-2.018,0-3.669-1.651-3.669-3.669l0,0 c0-2.018,1.651-3.669,3.669-3.669h95.656c2.018,0,3.669,1.651,3.669,3.669l0,0C732.603,811.91,730.952,813.561,728.934,813.561 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M676.642,787.502L676.642,787.502c0.93,0.283,1.909-0.293,2.176-1.28l1.743-6.447 c0.267-0.987-0.276-2.026-1.206-2.31l0,0c-0.93-0.283-1.909,0.293-2.176,1.28l-1.743,6.447 C675.17,786.179,675.712,787.219,676.642,787.502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M683.839,787.547L683.839,787.547c0.93,0.283,1.909-0.293,2.176-1.28l1.743-6.447 c0.267-0.987-0.276-2.026-1.206-2.31l0,0c-0.93-0.283-1.909,0.293-2.176,1.28l-1.743,6.447 C682.367,786.224,682.909,787.263,683.839,787.547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M691.036,787.592L691.036,787.592c0.93,0.283,1.909-0.293,2.176-1.28l1.743-6.447 c0.267-0.987-0.276-2.026-1.206-2.31l0,0c-0.93-0.283-1.909,0.293-2.176,1.28l-1.743,6.447 C689.564,786.269,690.107,787.309,691.036,787.592z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507087"
    },
    d: "M699.697,493.082c-16.453,0.145-30.192,8.321-33.962,19.244c-0.947,2.743,1.976,5.375,5.927,5.341 l56.506-0.498c3.951-0.035,6.827-2.719,5.832-5.445C730.037,500.869,716.151,492.937,699.697,493.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6977A"
    },
    d: "M688.48,482.369c-15.365,2.272-26.786,14.154-28.402,28.175c-0.406,3.521,2.788,6.413,6.478,5.867 l52.768-7.802c3.69-0.546,5.91-4.238,4.503-7.491C718.221,488.166,703.845,480.098,688.48,482.369z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB947B"
    },
    d: "M662.667,516.395l-112.853-10.038l2.545-28.609l133.51,16.661l-7.828,13.894 C674.951,513.787,668.936,516.953,662.667,516.395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78DBBE"
    },
    d: "M546.372,506.496l13.745-9.492c4.894-3.38,6.133-10.15,2.753-15.044l-62.427-90.4 c-3.38-4.894-10.15-6.133-15.044-2.753l-2.468,1.704c-11.097,7.663-13.906,23.012-6.243,34.109l54.639,79.122 C534.708,508.637,541.478,509.876,546.372,506.496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78DBBE"
    },
    d: "M658.925,490.678l-3.729,32.182c-0.127,1.077-1.11,1.846-2.183,1.705l-13.257-1.747l-7.308-0.965 l-8.774-1.152l-7.298-0.965l-8.774-1.157l-7.308-0.96l-59.155-7.8c-6.488-0.857-11.196-6.493-10.465-12.521l1.682-13.894 c0.731-6.029,6.633-10.264,13.121-9.411l59.684,7.762l7.308,0.951l8.779,1.143l7.303,0.946l8.774,1.143l7.308,0.951l12.615,1.64 C658.302,488.664,659.047,489.625,658.925,490.678z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4EB3AF"
    },
    points: "644.633,486.889 639.756,522.818 632.449,521.853 637.325,485.938  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4EB3AF"
    },
    points: "628.551,484.795 623.675,520.701 616.377,519.736 621.248,483.849  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4EB3AF"
    },
    points: "612.47,482.706 607.602,518.579 600.295,517.619 605.162,481.755  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D74C6B"
    },
    d: "M472.066,661.283h-25.744c-26.558,0-48.088-20.019-48.088-44.713V407.418 c0-5.987,5.219-10.84,11.658-10.84h50.517c6.438,0,11.658,4.853,11.658,10.84v180.847c0,10.399,6.393,19.882,16.458,24.415 l11.149,5.021L472.066,661.283z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F8EAA"
    },
    d: "M513.789,805.298L513.789,805.298c7.764,0,14.117-6.352,14.117-14.117v-86.504 c0-7.764-6.352-14.117-14.117-14.117h0c-7.764,0-14.116,6.352-14.116,14.117v86.504 C499.673,798.946,506.026,805.298,513.789,805.298z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1602 0.1602 0.9871 -126.0182 80.2646)",
    style: {
      fill: "#507087"
    },
    cx: 434.84,
    cy: 821.772,
    rx: 13.405,
    ry: 13.405
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -438.0454 586.0092)",
    style: {
      fill: "#507087"
    },
    cx: 488.353,
    cy: 821.772,
    rx: 13.405,
    ry: 13.405
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1602 0.1602 0.9871 -124.6362 97.4084)",
    style: {
      fill: "#507087"
    },
    cx: 541.866,
    cy: 821.772,
    rx: 13.405,
    ry: 13.405
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1602 0.1602 0.9871 -123.9452 105.9802)",
    style: {
      fill: "#507087"
    },
    cx: 595.38,
    cy: 821.772,
    rx: 13.405,
    ry: 13.405
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F8EAA"
    },
    d: "M436.616,816.727h156.534c7.827,0,14.23-6.403,14.23-14.23l0,0c0-7.827-6.403-14.23-14.23-14.23 H436.616c-7.827,0-14.23,6.404-14.23,14.23l0,0C422.386,810.323,428.79,816.727,436.616,816.727z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507087"
    },
    d: "M502.794,724.696h21.992c7.801,0,14.184-6.383,14.184-14.184v-55.773 c0-7.801-6.383-14.184-14.184-14.184h-21.992c-7.801,0-14.184,6.383-14.184,14.184v55.773 C488.609,718.313,494.992,724.696,502.794,724.696z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507087"
    },
    d: "M442.001,676.438h146.218c6.094,0,11.035-4.94,11.035-11.035v-9.236 c0-6.094-4.94-11.035-11.035-11.035H442.001c-6.094,0-11.035,4.94-11.035,11.035v9.236 C430.966,671.497,435.906,676.438,442.001,676.438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F8EAA"
    },
    d: "M565.105,565.21h-96.112c-3.616,0-6.574-2.958-6.574-6.574v-7.391c0-3.616,2.958-6.574,6.574-6.574 h96.112c3.616,0,6.574,2.958,6.574,6.574v7.391C571.679,562.252,568.721,565.21,565.105,565.21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F27792"
    },
    d: "M575.773,571.854h-73.443c-4.368,0-7.942-3.574-7.942-7.942v-17.665 c0-4.368,3.574-7.942,7.942-7.942h73.443c8.931,0,16.239,7.307,16.239,16.239v1.071 C592.011,564.547,584.704,571.854,575.773,571.854z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D74C6B"
    },
    d: "M588.527,565.637c-2.979,3.776-7.593,6.216-12.756,6.216h-73.443c-3.776,0-6.956-2.67-7.748-6.216 H588.527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F27792"
    },
    d: "M609.449,617.7H480.324c-12.877,0-23.315-9.706-23.315-21.679V407.418 c0-5.987-5.219-10.84-11.658-10.84h-50.517c-6.438,0-11.658,4.853-11.658,10.84V616.57c0,24.412,21.042,44.252,47.181,44.702 c0.922,0.112,1.859,0.175,2.813,0.175h176.279c12.002,0,21.821-9.13,21.821-20.29v-3.168 C631.271,626.831,621.451,617.7,609.449,617.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopViewBg);
export default __webpack_public_path__ + "static/media/DesktopView-bg.b46f948acfc6a23a2a3693282c0f989e.svg";
export { ForwardRef as ReactComponent };